import { Component } from '@inter-ikea-core/core';

/**
 * Added to shelves that are part of a frame article (frames in BILLY and corner frames in PAX)
 */
export default class IncludedShelfComponent implements Component {
  static id = 2007;
  typeId = IncludedShelfComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return false;
  }
}
